
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { useAuthContext } from '@/context-state/AuthContext.jsx'
import { useEffect } from 'react'

export default function SpaceDefault() {

    const { spaceId } = useParams()
    const { spaces, logout } = useAuthContext()
    const navigate = useNavigate()
    const { accountId } = useParams()


    useEffect(() => {
        // If there are no spaces, redirect to auth
        if (!spaces.length) {
            console.log('no spaces')
            logout()
            return
        }

        // Check if we're at the /account/:accountId/space route without a spaceId
        if (window.location.pathname === `/account/${accountId}/space`) {
            navigate(`/account/${accountId}/space/${spaces[0]._id}`)
            return
        }
        // Check if current spaceId exists in spaces
        const currentSpace = spaces.find(space => space._id === spaceId);

        // If space doesn't exist but others do, redirect to first space
        if (!currentSpace) {
            navigate(`/account/${accountId}/space/${spaces[0]._id}`);
        }
    }, [spaceId, spaces])

    // Get spaces for current account
    if (!spaces.length)  {
        return null
    }

    return <Outlet />

}